import { render, staticRenderFns } from "./ServiceStatuses.vue?vue&type=template&id=38e35a32&"
import script from "./ServiceStatuses.vue?vue&type=script&lang=js&"
export * from "./ServiceStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports